module.exports = __webpack_public_path__ + "static/media/webapp_background_stage.85993b60.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/webapp_background_stage/webapp_background_stage.png
// module id = 221
// module chunks = 0